import {computed} from 'vue'
import {useI18n} from 'vue-i18n'

const KNOWLEDGE_BASE_URL = 'https://knowledgebase.rateboard.io'
const knowledgeBaseLocales: Record<string, {path: string; language: string}> = {
  de: {path: '', language: 'de'},
  en: {path: '/en', language: 'en'},
  it: {path: '/it', language: 'it'},
}

export function useKnowledgeBaseUrl(articlePath?: string) {
  const {locale} = useI18n()

  const href = computed(() => {
    const {language, path} = knowledgeBaseLocales[locale.value] ?? knowledgeBaseLocales.en

    if (articlePath) {
      return `${KNOWLEDGE_BASE_URL}${path}/knowledge-base/${articlePath}`
    }

    const redirectUrl = encodeURIComponent(`${KNOWLEDGE_BASE_URL}${path}/knowledge-base`)
    return `${KNOWLEDGE_BASE_URL}/_hcms/mem/login?redirect_url=${redirectUrl}&hsLang=${language}`
  })

  return {
    href,
  }
}
